import { render } from "./DawaDirectory.vue?vue&type=template&id=227dbdc2&scoped=true"
import script from "./DawaDirectory.vue?vue&type=script&lang=js"
export * from "./DawaDirectory.vue?vue&type=script&lang=js"

import "./DawaDirectory.vue?vue&type=style&index=0&id=227dbdc2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227dbdc2"]])

export default __exports__